import TokenDetailsButton from './Button'

export default TokenDetailsButton
